import { ProductManualRecommendationEntity, ProductRecommendationEntity } from '@product/const/v2';
import { StateUtils } from '@spartacus/core';

export const PRODUCT_RECOMMENDATIONS_FEATURE = 'product-recommendations';
export const PRODUCT_RECOMMENDATION_ENTITY = '[Product-recommendation] Product-recommendation Entity';
export const PRODUCT_MANUAL_RECOMMENDATION_ENTITY =
  '[Product-manual-recommendation] Product-manual-recommendation Entity';

export interface StateWithProductRecommendations {
  [PRODUCT_RECOMMENDATIONS_FEATURE]: ProductRecommendationsState;
}

export interface ProductRecommendationsState {
  productRecommendation: StateUtils.LoaderState<ProductRecommendationEntity[]>;
  productManualRecommendation: StateUtils.LoaderState<ProductManualRecommendationEntity>;
}
